<template>
  <router-view />
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@500&display=swap');

body {
  letter-spacing: 1.5px;
  letter-spacing: calc(1px - 0.0625em);
  font-feature-settings: 'palt' 1;
  font-kerning: auto;
  color: #333;
}
</style>
